export const LOGIN_URL = process.env.NEXT_PUBLIC_USER_LOGIN_URL;
export const USER_URL = process.env.NEXT_PUBLIC_USER_HOME_ROUTE;
export const CRM_URL = process.env.NEXT_PUBLIC_USER_CRM_ROUTE;
export const CMS_URL = process.env.NEXT_PUBLIC_USER_CMS_ROUTE;
export const OPS_URL = process.env.NEXT_PUBLIC_USER_OPS_ROUTE || '/OPS';
export const HOME_URL = process.env.NEXT_PUBLIC_HOME_URL;
export const USER_ROUTE = process.env.NEXT_PUBLIC_USER_ROUTE;